<div class="main_wraper">
  <header class="clearfix">
    <div class="mid_container">
      <div class="mid_container_inner">
        <div class="logo"> <img src="assets/images/logo-aba.png" class="img-responsive" /></div>
      </div>
    </div>

    <div class="nav2 ">
      <div class="mid_container ">
        <div class="mid_container_inner">
          <div class="logo_text">BankExec®
            <div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>

  <div class="user_section clearfix">
    <div class="mid_container">
      <div class="mid_container_inner ">
        <div class="user_name"> Username: <b>{{email}}</b></div>
      </div>
    </div>
  </div>
  <section>
    <div class="container">
      <div class="login_wraper">
        <div class="row ">
          <div class="login_section">
            <div class=" col-lg-12">
              <p class="password_submit">Your password was sent.
                <a href="javascript:void(0)" (click)="Login()"> Click here to return to homepage.</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
